import { GoogleCalendarProps, defaults } from '@/components/ui/GoogleCalendar';
import { gravComponentSchema } from '../deep-form-grav';

const { s, l, bl, toExport } = gravComponentSchema<GoogleCalendarProps>({
  title: 'Google Calendar',
  link: '',
  text: text(),
},
  defaults,
);

export default toExport;

// Basic Settings
s.add('calendarId').input('text')
  .title('Calendar ID')
  .desc('Calendar ID')
  .mandatory()
  .props({ dfTitleInside: true })
  .col(12);

// Size Settings
s.add('width').input('text')
  .title('Width')
  .desc('Width of iframe (e.g. 800px or 100%)')
  .props({ dfTitleInside: true })
  .col(6);

s.add('height').input('text')
  .title('Height')
  .desc('Height of iframe (e.g. 600px)')
  .props({ dfTitleInside: true })
  .col(6);

// Localization Settings
s.add('ctz').input('text')
  .title('Timezone')
  .desc('Timezone (e.g. "Europe/Moscow")')
  .props({ dfTitleInside: true })
  .col(4);

s.add('hl').input('text')
  .title('Language')
  .desc('Interface language (e.g. "ru", "en", "kk")')
  .props({ dfTitleInside: true })
  .col(2);

s.add('wkst').input('dictionary')
  .data([
    { title: 'Sunday', value: 1 },
    { title: 'Monday', value: 2 },
    { title: 'Saturday', value: 7 },
  ])
  .title('First Day of Week')
  .desc('First day of the week')
  .props({ dfTitleInside: true, clearable: true })
  .col(3);

s.add('mode').input('dictionary')
  .data(['WEEK', 'MONTH', 'AGENDA'])
  .title('Display Mode')
  .desc('Calendar display mode')
  .props({ dfTitleInside: true, clearable: true })
  .col(3);

// Display Options - Row 1
s.add('showTitle').input('boolean')
  .title('Show Title')
  .desc('Show calendar title')
  .props({ dfTitleInside: true })
  .col(3);

s.add('showNav').input('boolean')
  .title('Show Navigation')
  .desc('Show navigation buttons')
  .props({ dfTitleInside: true })
  .col(3);

s.add('showDate').input('boolean')
  .title('Show Date')
  .desc('Show current date')
  .props({ dfTitleInside: true })
  .col(3);

s.add('showTabs').input('boolean')
  .title('Show Tabs')
  .desc('Show view mode tabs')
  .props({ dfTitleInside: true })
  .col(3);

// Display Options - Row 2
s.add('showPrint').input('boolean')
  .title('Show Print')
  .desc('Show print button')
  .props({ dfTitleInside: true })
  .col(3);

s.add('showCalendars').input('boolean')
  .title('Show Calendars')
  .desc('Show calendar list')
  .props({ dfTitleInside: true })
  .col(3);

s.add('showTz').input('boolean')
  .title('Show Timezone')
  .desc('Show timezone')
  .props({ dfTitleInside: true })
  .col(3);

// Style Settings
s.add('color').input('color')
  .title('Calendar Color')
  .desc('Calendar color (hex format)')
  .props({ dfTitleInside: true })
  .col(12);


function text() {
  return `
<b>UI Component: Google Calendar</b>
This component embeds Google Calendar into the page using iframe.
  `;
}
